"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  active: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  description: _propTypes["default"].string,
  fullscreen: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  theme: _propTypes["default"].oneOf(['light', 'dark'])
};
var defaultProps = {
  active: true,
  fullscreen: false,
  onClick: function onClick() {},
  theme: 'light'
};

var Spinner = function Spinner(_ref) {
  var theme = _ref.theme,
      fullscreen = _ref.fullscreen,
      active = _ref.active,
      className = _ref.className,
      onClick = _ref.onClick,
      description = _ref.description,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["theme", "fullscreen", "active", "className", "onClick", "description"]);

  var classes = (0, _classnames["default"])('grv-spinner', {
    'grv-spinner--active': active,
    'grv-spinner--dark': theme === 'dark',
    'grv-spinner--fullscreen': fullscreen
  }, className);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, otherProps, {
    className: classes,
    onClick: onClick,
    onKeyPress: onClick,
    role: "button",
    tabIndex: -1
  }), description ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "grv-spinner__description"
  }, description) : null);
};

Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;
var _default = Spinner;
exports["default"] = _default;